import { Flag } from "@medbillai/utils/flag";

import { useAuth } from "../../../lib/auth";
import { isBillCheckingTargeted } from "../../../lib/auth/utils";
import { useBoolVariation } from "../../../lib/flag";

export const useShouldShowUploadBill = () => {
  const { user } = useAuth();

  // Feature flag check
  const isExpediteBillUploadEnabled = useBoolVariation(
    Flag.EXPEDITE_BILL_UPLOAD,
    false,
  );

  // User segmentation check
  const userWantsBillingHelp = isBillCheckingTargeted(
    user?.userSegmentationData?.features,
  );

  return isExpediteBillUploadEnabled && userWantsBillingHelp;
};
